import { ApiRequest } from "@plinknz/tah-website-elements";
import { membersLogin } from "../../../config/router";

export const contactApi = new ApiRequest({
    baseUrl: process.env.REGISTRATION_URL || "https://localhost:3001",
    loginPath: membersLogin(),
});
